<app-bread-crumb></app-bread-crumb>

<!-- Main content -->
 <section class="content">

  <!-- Info boxes -->
  <div class="row">

    <div class="col-md-3 col-sm-6 col-xs-12" *ngIf="auth.user.roles[0].name=='user' || auth.user.roles[0].name=='admin' ">
     
      <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
        boxBorderColor:'#f35309',
        boxHeaderTitleLink:'/admin/partners',
        boxHeaderTitle:'Parceiros',
        boxHeaderTitleIcon:'fa fa-briefcase',
        boxContentValue:indicators?.totalParceiros || 0
      }"></box-dashboard>

    </div>

    <div class="col-md-3 col-sm-6 col-xs-12">
     
      <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
        boxBorderColor:'#f35309',
        boxHeaderTitleLink:'/admin/partnership',
        boxHeaderTitle:'Parcerias',
        boxHeaderTitleIcon:'fa fa-briefcase',
        boxContentValue:indicators?.totalPartinership || 0
      }"></box-dashboard>

    </div>

    <div class="col-md-3 col-sm-6 col-xs-12">
      
      <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
        boxBorderColor:'#f35309',
        boxHeaderTitleLink:'/admin/members',
        boxHeaderTitle:'Sócios',
        boxHeaderTitleIcon:'fa fa-users',
        boxContentValue:indicators?.totalMembros || 0
      }"></box-dashboard>

    </div>
    <div class="col-md-3 col-sm-6 col-xs-12" *ngIf="auth.user.roles[0].name=='user' || auth.user.roles[0].name=='admin' ">
      

      <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
        boxBorderColor:'#f35309',
        boxHeaderTitle:'Clubes',
        boxHeaderTitleLink:'/admin/clubs',
        boxHeaderTitleIcon:'fa fa-soccer-ball-o',
        boxContentValue:indicators?.totalClubes || 0
      }"></box-dashboard>
      
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12" *ngIf="auth.user.roles[0].name!=='userClube'">
      
      <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
        boxBorderColor:'#f35309',
        boxHeaderTitle:'Utilizadores',
        boxHeaderTitleLink:'/admin/users',
        boxHeaderTitleIcon:'fa fa-user',
        boxContentValue:indicators?.totalUtilizadores || 0
      }"></box-dashboard>

    </div>

  <!-- </div> -->
  <!-- fix for small devices only -->
  <!-- <div class="clearfix visible-sm-block"></div>
      <div class="row"> -->
        <div class="col-md-3 col-sm-6 col-xs-12">
          
          <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
            boxBorderColor:'#f35309',
            boxHeaderTitleLink:'/admin/news',
            boxHeaderTitle:'Notícias',
            boxHeaderTitleIcon:'fa fa-newspaper-o',
            boxContentValue:indicators?.totalNoticias || 0
          }"></box-dashboard>
    
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12" *ngIf="auth.user.roles[0].name=='user' || auth.user.roles[0].name=='admin' ">
          
    
          <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
            boxBorderColor:'#f35309',
            boxHeaderTitle:'Serviços',
            boxHeaderTitleLink:'/admin/services',
            boxHeaderTitleIcon:'fa  fa-wrench',
            boxContentValue:indicators?.totalServicos || 0
          }"></box-dashboard>
          
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
         
          <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
            boxBorderColor:'#f35309',
            boxHeaderTitleLink:'/admin/quotes',
            boxHeaderTitle:'Quotas',
            boxHeaderTitleIcon:'fa fa-dollar',
            boxContentValue:indicators?.totalQuotas || 0
          }"></box-dashboard>
    
        </div>
    
       
       
        <div class="col-md-3 col-sm-6 col-xs-12">
          
          <box-dashboard [loadingSpin]="loadingSpinner" [box]="{
            boxBorderColor:'#f35309',
            boxHeaderTitle:'Produtos',
            boxHeaderTitleLink:'/admin/products/list',
            boxHeaderTitleIcon:'fa fa-shopping-cart',
            boxContentValue:indicators?.totalProduct || 0
          }"></box-dashboard>
    
        </div>
    
      </div>

</section>